import EndpointsBase from "../EndpointsBase";
import { ISortBoxItemModel } from "../SortBoxItem/ISortBoxItemModel";
import { IStockItem } from "./IStockItem";
import { IMissingStockItem } from "./IMissingStockItem";

class SkuEndpoints extends EndpointsBase {
  everificationScan(skuID: number, boxID: number, eVerificationScan: string) {
    return this._sendRequest({
      method: "sku/everificationScan",
      headers: this._getAuthHeader(),
      data: { skuID, boxID, eVerificationScan },
      run: this.server.postData,
    });
  }

  setFoundQuantity(
    skuID: number,
    boxID: number,
    foundShelves: { foundQuantity: number; shelfNumber: string }[],
    maxMissingQuantity: number,
    fromReview: boolean,
    operatorID: string,
    isScanIdValidationRemoveSkuRequired: boolean,
    partialDelivery: boolean,
    isRxItem:boolean,
    originalShelfNumber: string,
  ) {
    return this._sendRequest<ISortBoxItemModel[]>({
      method: "Sku/foundquantity",
      data: {
        skuID,
        boxID,
        foundShelves,
        maxMissingQuantity,
        fromReview,
        operatorID,
        isScanIdValidationRemoveSkuRequired,
        partialDelivery,
        isRxItem,
        originalShelfNumber
      },
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }
  reportMissingStockItem(
    boxItem: {
      skuID: string;
      shelfNumber: string;
      boxID: string;
      reservedQuantity: number;
      verifiedQuantity: number;
    },
    reasonCode: string
  ) {
    const { skuID: sku, shelfNumber, boxID } = boxItem;
    const quantityMissing = (boxItem.reservedQuantity - boxItem.verifiedQuantity == 0)? boxItem.reservedQuantity: boxItem.reservedQuantity - boxItem.verifiedQuantity;

    return this._sendRequest<IMissingStockItem>({
      method: "sku/missingStockItem",
      data: {
        sku,
        shelfNumber,
        boxID,
        quantityMissing,
        reasonCode,
      },
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }

  updateMissingStockItemState(
    missingStockItemTrackingID: string,
    actionTaken: number,
    actionContext: Record<string, string>
  ) {
    return this._sendRequest({
      method: "sku/updateMissingStockItemState",
      data: {
        itemID: missingStockItemTrackingID,
        resolutionAction: actionTaken,
        resolutionActionContext: actionContext,
      },
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }
  getStockListForSku(skuID: number, branchId: number) {
    return this._sendRequest<IStockItem[]>({
      method: "sku/getStockListForSku",
      data: {skuID, branchId},
      headers: this._getAuthHeader(),
      run: this.server.getData,
    });
  }

  setWeightOnSku(skuID: number, weight: number) {
    return this._sendRequest({
      method: "sku/SetWeightOnSku",
      data: {
        weight,
        skuID,
      },
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }


  getWeightSku(skuID: number) {
    return this._sendRequest({
      method: "sku/GetWeightSku",
      data: {
        skuID,
      },
      headers: this._getAuthHeader(),
      run: this.server.getData,
    });
  }

  checkWeightForSku(skuID?: number) {
    return this._sendRequest({
      method: "sku/CheckWeightForSku",
      data: {
        skuID,
      },
      headers: this._getAuthHeader(),
      run: this.server.getData,
    });
  }
  GetEANFrom2D(scan: string) {
    return this._sendRequest({
      method: "sku/GetEANFrom2D",
      data: { scan },
      headers: this._getAuthHeader(),
      run: this.server.getData,
    });
  }
}

export default new SkuEndpoints();
